// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607290434/js/" + chunkId + "." + {"44":"1b458850","225":"f2f9926d","481":"a5329acb","486":"e9fb4689","770":"89cb8308"}[chunkId] + ".0.7691832860842807.chunk.js";
};